"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclTranslationsIt = void 0;
exports.aclTranslationsIt = {
    // ACL Resources
    'acl_resource.company': 'Azienda',
    'acl_resource.user': 'Utente',
    'acl_resource.user_group': 'Gruppo Utenti',
    'acl_resource.settings_general': 'Impostazioni Generali',
    'acl_resource.settings_access': 'Impostazioni di Accesso',
    'acl_resource.settings_styles': 'Impostazioni Stili',
    'acl_resource.avatar': 'Avatar',
    'acl_resource.ai': 'IA',
    'acl_resource.knowledge': 'Conoscenza',
    'acl_resource.project': 'Progetto',
    'acl_resource.onboarding': 'Onboarding',
    'acl_resource.reports': 'Report',
    // ACL Actions
    'acl_action.read': 'Leggere',
    'acl_action.write': 'Scrivere',
    'acl_action.delete': 'Eliminare',
};
